import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import duimages from "../Images/du.png";

import logout from "../Images/logout.png";
import MoneyCounter from "./MoneyCounter";

import credit from "../Images/cr.png";
import loan from "../Images/cr.png";
import more from "../Images/more.png";

import { RiFeedbackFill } from "react-icons/ri";

const Header = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isRole, setIsRole] = useState("false");
  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      setIsLoggedIn(true);
      const role = localStorage.getItem("role");
      if (role) {
        setIsRole(role);
      }
    }
  }, []);
  const [open, setOpen] = useState(false);
  return (
    <div className="header">
      <div className="container">
        <div className="row">
          <div className="col-md-4 col-3">
            <div className="logo">
              <Link to="/">BG Oil</Link>
            </div>
          </div>
          <div className="col-md-8 col-9 d-flex justify-content-end v">
            <nav>
              <ul>
                <li>
                  <Link to="/dashboard">
                    {" "}
                    <img src={duimages} alt="Du" />
                    Home
                  </Link>
                </li>

                <>
                  <li>
                    <Link to="/credit">
                      <img src={credit} alt="Credit" />
                      Credit
                    </Link>
                  </li>
                </>

                <li>
                  <Link to="/costomercont">
                    <RiFeedbackFill />
                    Customers
                  </Link>
                </li>
                <li>
                  <Link>
                    <MoneyCounter />
                  </Link>
                </li>
                {(isRole === "ADMIN" || isRole === "MANAGER") && (
                  <>
                    <div className="menu-container">
                      <button
                        className="menu-button"
                        onClick={() => setOpen(!open)}
                      >
                        <img src={more} alt="more" />
                        More
                      </button>
                      {open && (
                        <div className="dropdown">
                          <li>
                            <Link to="/sales">
                              <img src={credit} alt="Credit" />
                              Sales
                            </Link>
                          </li>
                          <li>
                            <Link to="/production">
                              <img src={duimages} alt="production" />
                              Production
                            </Link>
                          </li>
                          <li>
                            <Link to="/loan">
                              <img src={loan} alt="Loan" />
                              Loan
                            </Link>
                          </li>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {isLoggedIn ? (
                  <li>
                    <Link to="/logout">
                      {" "}
                      <img src={logout} alt="Logout" /> Logout
                    </Link>
                  </li>
                ) : (
                  <li>
                    <Link to="/">
                      {" "}
                      <img src={logout} alt="Login" />
                      Login
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
